import { render, staticRenderFns } from "./m_search.vue?vue&type=template&id=8c1622c0&"
import script from "./m_search.vue?vue&type=script&lang=js&"
export * from "./m_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports